import {
  SERVICE_PLAN_ADD_NEW,
  SERVICE_PLAN_ADD_NEW_SUCCESS,
  SERVICE_PLAN_ADD_NEW_ERROR,
  SERVICE_PLAN_DELETE,
  SERVICE_PLAN_DELETE_ERROR,
  SERVICE_PLAN_DELETE_SUCCESS,
  SERVICE_PLAN_EDIT,
  SERVICE_PLAN_EDIT_ERROR,
  SERVICE_PLAN_EDIT_SUCCESS,
  SERVICE_PLAN_GET_BY_ID,
  SERVICE_PLAN_GET_BY_ID_ERROR,
  SERVICE_PLAN_GET_BY_ID_SUCCESS,
  SERVICE_PLAN_GET_LIST,
  SERVICE_PLAN_GET_LIST_ERROR,
  SERVICE_PLAN_GET_LIST_SUCCESS,
  SERVICE_PLAN_ADD_NEW_REQUEST,
  NOTIFICATION_GET_LIST_SUCCESS,
  SERVICE_PLAN_STATUS_CHANGE,
  SERVICE_PLAN_STATUS_CHANGE_SUCCESS,
  SERVICE_PLAN_STATUS_CHANGE_ERROR,
} from '../actions';

// servicePlan
const initialState = {
  servicePlans: [],
  servicePlan: null,
  notifications: [],
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SERVICE_PLAN_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case SERVICE_PLAN_STATUS_CHANGE:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case SERVICE_PLAN_STATUS_CHANGE_SUCCESS:
      return {
        ...state,
        servicePlans: state.servicePlans.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        servicePlan: payload,
        error: null,
        loading: false,
      };
    case SERVICE_PLAN_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePlan: payload,
      };

    case SERVICE_PLAN_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case SERVICE_PLAN_GET_LIST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case SERVICE_PLAN_GET_LIST_SUCCESS:
      return {
        ...state,
        servicePlans: payload,
        loading: false,
      };
    case SERVICE_PLAN_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case SERVICE_PLAN_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePlan: payload,
        servicePlans: state.servicePlans.concat(payload),
        addSuccess: true,
      };

    case NOTIFICATION_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: payload,
        addSuccess: true,
      };

    case SERVICE_PLAN_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case SERVICE_PLAN_EDIT_SUCCESS:
      return {
        ...state,
        servicePlans: state.servicePlans.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        servicePlan: payload,
        error: null,
        loading: false,
        editSuccess: true,
      };
    case SERVICE_PLAN_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };
    case SERVICE_PLAN_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        servicePlans: state.servicePlans.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case SERVICE_PLAN_DELETE_ERROR:
    case SERVICE_PLAN_ADD_NEW_ERROR:
    case SERVICE_PLAN_EDIT_ERROR:
    case SERVICE_PLAN_GET_BY_ID_ERROR:
    case SERVICE_PLAN_GET_LIST_ERROR:
    case SERVICE_PLAN_STATUS_CHANGE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
